class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    // Detect Safari
     this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
                    (navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome'));

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
       // Add special handling for Safari
       if (this.isSafari) {
         this.input.addEventListener('focus', this.onSafariFocus.bind(this));
       }
     }
   }
   
   // Safari-specific focus handler
   onSafariFocus() {
     // Force redraw of the search container in Safari
     const searchContainer = this.closest('.search-modal__form');
     if (searchContainer) {
       // Give the browser time to focus and then force redraw
       setTimeout(() => {
         const predictiveSearch = this.closest('predictive-search');
         if (predictiveSearch) {
           const resultsContainer = predictiveSearch.querySelector('[data-predictive-search]');
           if (resultsContainer) {
             resultsContainer.style.display = 'block';
             resultsContainer.style.opacity = '1';
             resultsContainer.style.visibility = 'visible';
           }
         }
       }, 100);
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
